var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondBnbChainAdaptiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BNB Chain"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse",
    filter: "url(#filter0_f_1877_18497)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.0502,
    cy: 31.113,
    rx: 31.0502,
    ry: 31.113,
    transform: "matrix(0.985157 -0.171656 0.142501 0.989795 36 45.6602)",
    fill: "#CEA201",
    fillOpacity: 0.33
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    filter: "url(#filter1_f_1877_18497)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.0502,
    cy: 31.113,
    rx: 31.0502,
    ry: 31.113,
    transform: "matrix(0.985157 -0.171656 0.142501 0.989795 36 45.6602)",
    fill: "#CEA201",
    fillOpacity: 0.97
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M60.9564 89.2606C58.5482 88.5581 56.152 87.8293 53.7267 87.1756C52.9362 86.9603 52.5456 86.6327 52.4807 85.7904C52.1878 81.9648 51.7884 78.1622 51.4386 74.3468C51.4072 74.0145 51.2627 73.6852 51.4929 73.2319L56.0587 74.5409C56.5552 74.6846 56.4834 75.1272 56.5183 75.4974C56.7127 77.5608 57.0813 79.6015 57.0515 81.6941C57.0287 83.1434 57.9181 83.64 59.0622 83.8669C61.3159 84.3131 63.3725 85.1539 65.6006 85.6356C66.0098 85.7253 66.0383 86.0281 66.0687 86.35C66.2005 87.7487 66.3321 89.1453 66.4811 90.727L61.0542 89.3253C61.0568 89.3132 61.0559 89.3012 61.0517 89.2905C61.0475 89.2798 61.0401 89.2707 61.0302 89.2642C61.0203 89.2577 61.0083 89.2539 60.9954 89.2533C60.9824 89.2526 60.969 89.2551 60.9564 89.2606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M81.3311 52.7802C80.1281 53.6869 78.9129 54.5822 77.7276 55.509C77.2678 55.868 76.8867 56.0254 76.324 55.8542C74.0806 55.1742 71.8008 54.5655 69.5572 53.8835C69.0246 53.72 68.6584 53.7687 68.1625 54.1532C66.2533 55.6396 64.2915 57.0694 62.3824 58.5578C61.6931 59.1002 61.1119 59.3432 60.2951 59.038C59.1241 58.5918 57.8469 58.2932 56.618 57.9308C59.8591 55.4822 63.0334 52.9926 66.2742 50.54C66.4118 50.4168 66.6034 50.3215 66.7133 50.1786C67.8748 49.1651 68.8692 49.0408 70.2989 49.5484C72.0407 50.18 74.7376 51.0636 75.3812 51.1862C75.5063 51.2244 75.8306 51.3122 75.9055 51.3338C77.7388 51.8612 79.1528 52.3137 80.9124 52.6229L81.3311 52.7802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M72.3056 93.8742C73.7007 94.3231 75.0598 94.7232 76.3412 93.3462L76.7962 92.8919C78.6456 90.8556 79.1593 90.5391 78.7105 88.2253C78.3158 86.1909 78.3464 86.0492 76.5781 87.6823C74.8612 89.273 73.4102 89.7545 71.3718 88.8835C69.3335 88.0125 69.2128 88.2051 69.3899 90.3847C69.6068 93.0625 69.6405 93.0032 72.3056 93.8742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M67.4526 79.3151C67.3497 78.2214 67.2126 77.1353 67.1574 76.029C67.1234 75.3956 66.8404 75.1352 66.1857 74.9585C63.8619 74.3459 61.5941 73.61 59.2835 72.9632C59.0559 72.9246 58.8592 72.8172 58.7221 72.6566C58.5851 72.496 58.5149 72.2907 58.5218 72.0706C58.4505 70.8674 58.3332 69.6701 58.1843 68.4839C58.1412 68.2898 58.1699 68.0781 58.2662 67.8801C58.3625 67.6821 58.5212 67.5083 58.719 67.3844C59.8287 66.5545 60.9222 65.7009 61.9873 64.8179C62.4541 64.4328 62.8396 64.3963 63.3405 64.5461C65.6695 65.2392 68.0216 65.8812 70.3431 66.5697C70.8537 66.7236 71.2028 66.6721 71.6771 66.2916C73.7136 64.6677 75.8028 63.1098 77.829 61.4756C78.479 60.9581 78.9966 60.7419 79.6682 61.072C80.055 61.2761 80.4731 61.4345 80.9143 61.5441C81.8645 61.7419 83.2888 61.7058 83.5289 62.4008C84.0141 63.7959 83.9325 65.4284 84.0702 66.9668C84.1031 67.3156 83.7139 67.4366 83.484 67.6169C81.4672 69.203 79.4635 70.8029 77.4071 72.339C76.6805 72.8838 76.4141 73.3694 76.5147 74.1662C76.791 76.336 76.9261 78.5388 77.1667 80.7248C77.2221 81.3137 77.0859 81.7477 76.4954 82.1056C76.3659 82.1954 76.242 82.2926 76.1245 82.3964C72.3608 85.3166 72.3642 85.3033 68.3324 83.7398C67.8876 83.5673 67.802 83.2761 67.7657 82.8904C67.6532 81.6941 67.5408 80.4999 67.4282 79.3036L67.4526 79.3151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M80.5614 88.7535C80.4166 87.2162 80.2956 85.7789 80.1465 84.3498C80.1068 83.9292 80.2911 83.7069 80.656 83.4306C82.8607 81.7519 85.0279 80.0342 87.2411 78.3687C87.5114 78.1952 87.7277 77.9562 87.8594 77.6856C87.9911 77.4149 88.0315 77.1262 87.9751 76.8602C87.7169 74.5555 87.5391 72.2335 87.2941 69.9411C87.2401 69.6908 87.2787 69.4186 87.4045 69.164C87.5302 68.9095 87.7366 68.686 87.9934 68.5259C89.2444 67.6115 90.4425 66.6485 91.6349 65.7274C91.9996 65.8073 91.9225 66.0643 91.9403 66.2536C92.3226 70.3103 92.693 74.3696 93.106 78.4196C93.1563 78.6507 93.1226 78.9018 93.0099 79.1378C92.8971 79.3738 92.7108 79.5829 92.477 79.7359C88.6492 82.6563 84.8521 85.5957 81.0419 88.5251C80.8878 88.614 80.7269 88.6905 80.5614 88.7535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M80.45 58.5216C81.9115 57.3753 83.2302 56.3596 84.5228 55.3158C84.8762 55.0271 85.1505 55.0957 85.4693 55.1883C86.7155 55.5482 87.9565 55.9282 89.2194 56.2655C89.7565 56.4052 89.9242 56.7146 89.9548 57.2146C90.0239 58.3227 90.0934 59.4349 90.278 60.5219C90.3388 60.7782 90.3084 61.0581 90.1908 61.3235C90.0733 61.5889 89.8743 61.8267 89.6211 62.0046C88.5746 62.8424 87.4964 63.6427 86.4548 64.4815C85.924 64.9084 85.7986 64.6994 85.7568 64.2547C85.6531 63.1542 85.5194 62.0582 85.4451 60.9449C85.4078 60.2986 85.2217 59.9193 84.4656 59.7495C83.1729 59.4442 81.9379 58.9783 80.45 58.5216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M59.3134 61.7961C58.0795 62.7614 57.087 63.621 56.0057 64.3607C55.1868 64.9183 54.7862 65.4537 54.9424 66.3398C55.1227 67.3558 55.1372 68.4081 55.253 69.4381C55.3059 70.0007 55.2006 70.2539 54.5156 70.0391C53.3065 69.6711 52.0984 69.3136 50.8662 68.9993C50.4348 68.8829 50.3207 68.644 50.2912 68.2811C50.1712 67.0071 50.0743 65.728 49.9313 64.459C49.8955 64.2769 49.9254 64.0798 50.0169 63.896C50.1085 63.7122 50.2568 63.5509 50.441 63.4352C51.6161 62.544 52.7794 61.6279 53.928 60.7046C54.0545 60.5835 54.2135 60.4969 54.3824 60.4572C54.5512 60.4175 54.7212 60.4267 54.8679 60.4835C56.2719 60.9015 57.6894 61.3123 59.3134 61.7961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M59.554 75.8305C61.2882 76.3278 62.7977 76.7687 64.3157 77.1971C64.6697 77.2963 64.697 77.5606 64.7236 77.8422C64.8424 79.1033 64.9494 80.3669 65.0905 81.6081C65.1654 82.2503 64.8585 82.2674 64.355 82.117C63.0861 81.7483 61.8178 81.3603 60.5342 81.0142C60.1034 80.893 59.9975 80.6393 59.9644 80.2626C59.8469 78.8618 59.7083 77.4678 59.554 75.8305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M79.8031 77.3072C79.0405 75.548 79.9518 74.2803 81.7544 73.2124C82.343 72.8705 82.8368 72.3611 83.3958 71.9593C83.9188 71.5825 84.2516 71.6042 84.2978 72.2466C84.3826 73.4359 84.4941 74.6195 84.6323 75.7973C84.6672 75.9647 84.6426 76.146 84.5617 76.3167C84.4809 76.4874 84.3477 76.6391 84.1804 76.7511C83.0295 77.6302 81.8861 78.5205 80.7502 79.422C80.226 79.8376 80.01 79.7584 79.9761 79.1947C79.9376 78.5571 79.8621 77.9339 79.8031 77.3072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M65.1884 61.026C66.4463 60.0448 67.5734 59.2526 68.5918 58.3474C69.3315 57.6854 69.9242 57.6759 70.6843 57.9663C71.7925 58.3915 73.0356 58.574 74.1985 59.1442L70.3128 62.1587C70.2067 62.2435 70.0808 62.3023 69.9498 62.3283C69.8189 62.3543 69.6881 62.3465 69.573 62.3057C68.1652 61.9001 66.7682 61.4882 65.1884 61.026Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1877_18497",
    x: 0.809376,
    y: 0.567188,
    width: 140.428,
    height: 141.116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.65,
    result: "effect1_foregroundBlur_1877_18497"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1877_18497",
    x: 0.809376,
    y: 0.567188,
    width: 140.428,
    height: 141.116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.65,
    result: "effect1_foregroundBlur_1877_18497"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondBnbChainAdaptiveIcon);
export default __webpack_public_path__ + "static/media/SecondBNBChainAdaptiveIcon.b68b8288070755159c91f101dff91150.svg";
export { ForwardRef as ReactComponent };